import type React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CognitoFormEmbed from "~/components/ui/cognitoFormEmbed";
import { CommonButton } from "~/components/ui/commonButton";
import SelectPlan from "~/features/billings/selectPlan";
import BackLeftArrow from "~/images/back_arrow.svg?react";
import type { RootState } from "~/store";

const PlanChangePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { organization, currentUser } = useSelector((state: RootState) => state.auth);

  if (!organization) return null;

  const isAdmin = currentUser?.role === "admin";
  const selectedPlan = (location.state as { plan?: string } | null)?.plan || "";

  if (!isAdmin) {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-2xl font-semibold text-gray-900">プラン変更</h1>
        <p className="text-sm text-gray-700">プラン変更は管理者のみ操作できます。</p>
        <div>
          <CommonButton variant="label" onClick={() => navigate(`/${organization.id}/billings`)}>
            戻る
          </CommonButton>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-2 mb-4">
        <button
          type="button"
          onClick={() => navigate(`/${organization.id}/billings`)}
          className="bg-transparent border-0 cursor-pointer flex items-center"
        >
          <BackLeftArrow />
        </button>
        <h1 className="text-2xl font-semibold text-gray-900">プラン変更</h1>
      </div>

      {!selectedPlan ? (
        <div className="flex flex-col gap-4">
          <p className="text-sm text-gray-700">変更したいプランを選択してください。</p>
          <SelectPlan showHeader={false} />
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between gap-4">
            <p className="text-sm text-gray-700">
              選択したプラン: <span className="font-medium">{selectedPlan}</span>
            </p>
            <CommonButton
              variant="label"
              onClick={() =>
                navigate(`/${organization.id}/billings/plan-change`, { replace: true })
              }
            >
              プランを選びなおす
            </CommonButton>
          </div>
          <div style={{ height: "calc(100vh - 160px)", minHeight: "600px" }}>
            <CognitoFormEmbed paymentId={organization.payment_id} plan={selectedPlan} />
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanChangePage;
